// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"5e74a30d","59":"71cc5df3","169":"71b9e0b8","227":"204cfee6","488":"29b71886","735":"5353191f","885":"a6ca7068"}[chunkId] + ".chunk.js";
};